{
	"type": "line",
	"minzoom": 8,
	"layout": {},
	"paint": {
		"line-color": [
			"match",
			["get", "facility_type"],
			"Bicycle Paths",
			"#378500",
			"Shared Paths",
			"#52d652",
			"Quietway",
			"#6161ff",
			"Lanes",
			"#80bfff",
			"Roads",
			"#d9b3ff",
			"Shoulders",
			"#faae3b",
			"Excluded",
			"#ff4040",
			"#828282"
		],
		"line-width": 2.6
	}
}
